import React, { useCallback, useState } from 'react';
import { connect } from 'react-redux';
import * as R from 'ramda';
import Button from '@mui/material/Button';
import Icon from '@mui/material/Icon';
import { returnField } from '../utils/formHelpers';
import { updateUserProfile } from '../store/actions/userActions';

import CardWrapper from '../components/common/CardWrapper';
import Grid from '@mui/material/Grid';

import { withTranslation } from 'react-i18next';
import { withRouter } from '../utils/withRouter'
import { Field } from '../components/Field/Field.js'
import { fastDeepEqual } from '../utils/object.js'


const User = ({
  i18n,
  initialValues,
  t,
  updateUserProfile
}) => {
  const [formValues, setFormValues] = useState(initialValues)
  const [submitting, setSubmitting] = useState(false)

  const submitForm = useCallback(async event => {
    event.preventDefault()
    setSubmitting(true)
    await updateUserProfile(formValues)
    setSubmitting(false)
  }, [formValues, updateUserProfile])

  const locale = i18n.language;
  const pristine = fastDeepEqual(initialValues, formValues)

  return (
    <CardWrapper
      name={t('userManagement.editUser')}
      caption={t('userManagement.viewSummary')}
      headline
      transparent
    >
      <form onSubmit={submitForm}>
        <CardWrapper>
          <Grid container spacing={4} direction="row" alignContent="flex-start" alignItems="flex-start">
            <Grid item xs={12} md={6}>
              <Field
                component={returnField('text')}
                fullWidth
                label={t('labels.firstName')}
                name="firstname"
                required
                setValue={setFormValues}
                type="text"
                value={formValues.firstname}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Field
                component={returnField('text')}
                fullWidth
                label={t('labels.lastName')}
                name="lastname"
                required
                setValue={setFormValues}
                type="text"
                value={formValues.lastname}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Field
                component={returnField('text')}
                fullWidth
                label={t('labels.company')}
                name="company"
                required
                setValue={setFormValues}
                type="text"
                value={formValues.company}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Field
                component={returnField('text')}
                fullWidth
                label={t('labels.email')}
                name="email"
                required
                setValue={setFormValues}
                type="email"
                value={formValues.email}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Field
                component={returnField('text')}
                fullWidth
                label={t('labels.title')}
                name="title"
                required
                setValue={setFormValues}
                type="text"
                value={formValues.title}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Field
                component={returnField('text')}
                fullWidth
                label={t('labels.phone')}
                name="phone"
                required
                setValue={setFormValues}
                type="text"
                value={formValues.phone}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Field
                component={returnField('select')}
                fullWidth
                id="role"
                label={t('labels.role')}
                multiple
                name="role"
                normalize={value => (( (Array.isArray(value) && value.length === 0)) || !Array.isArray(value) ? ['owner'] : value)}
                required
                selOpts={['owner', 'constructor', 'propertyManager', 'broker']}
                setValue={setFormValues}
                translateOptions
                type="text"
                value={formValues.role}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Field
                component={returnField('select')}
                fullWidth
                id="area"
                label={t('labels.area')}
                multiple
                name="area"
                normalize={value => (((Array.isArray(value) && value.length === 0)) || !Array.isArray(value) ? ['wholeFinland'] : value)}
                required
                selOpts={['wholeFinland', 'helsinkiMetropolitanArea', 'tampere', 'oulu', 'turku', 'jyväskylä', 'otherFinland']}
                setValue={setFormValues}
                translateOptions
                type="text"
                value={formValues.area}
              />
            </Grid>
          </Grid>
          <br />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={pristine || submitting}
          ><Icon>save</Icon> {t('userManagement.saveUser')}
          </Button>
          <br /><br />
          <a
            href={locale === 'fi'
              ? 'https://www.newsec.fi/tietosuojaseloste-tenrep/'
              : 'https://www.newsec.fi/privacy-statementclients/'}
            rel="noopener noreferrer"
            style={{
              color: '#999',
              fontSize: '.8em',
              textDecoration: 'underline'
            }}
            target="_blank"
          >{t('userManagement.privacyStatement')}</a>
        </CardWrapper>
      </form>
    </CardWrapper>
  );
};


const mapStateToProps = (state, ownProps) => {
  const userId = R.path(['router', 'params', 'userId'], ownProps) || R.path(['userId'], ownProps);
  const users = R.path(['user', 'users'], state);

  const { profile } = users[userId];

  const initialValues = { role: [], area: [], ...profile };

  return ({
    initialValues,
  });
};
const mapDispatchToProps = (dispatch, ownProps) => ({
  updateUserProfile: formContent => dispatch(updateUserProfile(formContent, R.path(['t'], ownProps))),
});

export default withRouter(withTranslation('translations')(connect(
  mapStateToProps,
  mapDispatchToProps,
)(User)));
